import { render, staticRenderFns } from "./SkimovieSpotEdit.vue?vue&type=template&id=67d0e2c4&scoped=true&"
import script from "./SkimovieSpotEdit.vue?vue&type=script&lang=js&"
export * from "./SkimovieSpotEdit.vue?vue&type=script&lang=js&"
import style0 from "./SkimovieSpotEdit.vue?vue&type=style&index=0&id=67d0e2c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d0e2c4",
  null
  
)

export default component.exports